'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _RocketPackages = require('./RocketPackages.scss');var styles = _interopRequireWildcard(_RocketPackages);

var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _packagesData = require('../../packagesData');
var _PackageDesktop = require('./PackageDesktop');var _PackageDesktop2 = _interopRequireDefault(_PackageDesktop);
var _PackedgeMobile = require('./PackedgeMobile');var _PackedgeMobile2 = _interopRequireDefault(_PackedgeMobile);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var RocketPackages = function RocketPackages(props) {
  var renderPackageDesktop = function renderPackageDesktop(packageInstance) {
    var Components = props.isMobile ? _PackedgeMobile2.default : _PackageDesktop2.default;

    return (
      _react2.default.createElement(Components, {
        handleChoosePackage: props.handleChoosePackage,
        key: packageInstance.id,
        isRtl: props.isRtl,
        packageInstance: packageInstance,
        translate: props.translate('rocketPromotion'),
        locale: props.locale,
        changeSelectedPackage: props.changeSelectedPackage,
        selectedPackage: props.selectedPackage }));


  };

  return (
    _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.rocketPackagesWrapper, { rtl: props.isRtl }) },
      _react2.default.createElement('div', { className: styles.packageWrapper },
        _packagesData.rocketPackages.map(renderPackageDesktop)),

      _react2.default.createElement('p', { className: styles.excludingVat }, props.translate('excludingVat'))));


};

RocketPackages.propTypes = {
  handleChoosePackage: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  changeSelectedPackage: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  selectedPackage: _propTypes2.default.string,
  isAgent: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(state) {return {
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    isAgent: (0, _get2.default)(state, 'userAuthentication.data.is_agent'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile };};exports.default =


(0, _reactRedux.connect)(mapStateToProps)(RocketPackages);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RocketPackages/RocketPackages.js
// module id = 2893
// module chunks = 0